<template>
  <el-row>
    <table-template  @onDataFilter="onDataFilter" :queryParams="queryParams" actionUrl="/channel/findChannelIndexTabConfig.action"
                    ref="indexTabConfigManagementTable">
      <template slot="search">
      </template>
      <template slot="item">
        <el-table-column
            label="名称"
            prop="name">

        </el-table-column>
        <el-table-column
            label="显示状态"
            >
        <template scope="scope">
          <el-switch
              style="display: block"
              v-model="scope.row.switch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="2"
              active-text="显示"
              inactive-text="隐藏"
              @change="changeSwitch(scope.$index,scope.row)"
             >
          </el-switch>
        </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button  @click="upLayer(scope.$index,scope.row)">上移</el-button>
            <el-button  @click="downLayer(scope.$index,scope.row)" >下移 </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelModel from '@/framework/models/channelModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'index-tab-config-management',
  data: function () {
    return {
      queryParams: {},
      data: [],
      channelId: null
    }
  },
  created () {
    let loginInfo = this.loginInfo
    this.channelId = loginInfo.id
  },
  methods: {
    changeSwitch (index, row) {
      var that = this
      let upDate = that.data[index].switch = row.switch

      that.saveData(JSON.stringify(that.data))
    },
    upLayer (index, row) {
      var that = this
      if (index === 0) {
        that.$message({
          message: '处于顶端，不能继续上移',
          type: 'warning'
        })
      } else {
        let upDate = that.data[index - 1]
        that.data.splice(index - 1, 1)
        that.data.splice(index, 0, upDate)
      }

      that.saveData(JSON.stringify(that.data))
    },
    downLayer (index, row) {
      var that = this
      if (index + 1 === that.data.length) {
        that.$message({
          message: '处于末端端，不能继续下移',
          type: 'warning'
        })
      } else {
        let downDate = that.data[index + 1]
        that.data.splice(index + 1, 1)
        that.data.splice(index, 0, downDate)
      }
      that.saveData(JSON.stringify(that.data))
    },
    saveData: function (data) {
      let that = this
      let param = {
        indexTabConfig: data,
        id: this.channelId
      }
      let listener = {
        success: function () {
          that.$message({
            type: 'success',
            message: '操作成功！ '
          })
          that.$refs.indexTabConfigManagementTable.search()
        },
        error: function () {
          that.$message({
            type: 'error',
            message: '操作失败！ '
          })
        }
      }
      channelModel.updateChannelIndexTabConfig(that, param, listener)
    },
    onDataFilter: function (dataInfo) {
      this.data = dataInfo.data
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.indexTabConfigManagementTable.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
